import { useEffect, useState } from 'react';

export function useIsWide(): boolean {
    const isWindowWide = () => window.innerWidth >= 1260;

    const [isWide, setIsWide] = useState<boolean>(isWindowWide());

    useEffect(() => {
        function resizeHandler() {
            setIsWide(isWindowWide());
        }
        window.addEventListener('resize', resizeHandler);
        return () => window.removeEventListener('resize', resizeHandler);
    }, []);

    return isWide;
}
